module.exports = __webpack_public_path__ + "img/refreshWhite.ab807004.svg";